import React from "react";
import CreateRole from "../../settings/create role/CreateRole";
import { AuthContext } from "../../../util/context";
import { useContext } from "react";
import Login from "../../auth/Login";
import Dashboard from "../../dashboard/Dashboard";

export default function CreateRolePage() {
  let view;
  const { isAuthenticated, user } = useContext(AuthContext);

  const viewSettings = user?.job_role?.toLowerCase() === "seed";

  if (viewSettings) {
    view = <CreateRole />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated ? view : <Login />}</>;
}
